"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useRemoveHandler = void 0;
var _analyticsData = require("@ori/analytics-data");
var _logger = require("@ori/logger");
var _react = require("react");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
const useRemoveHandler = (removeProps)=>{
    const { setLoadingItem, setShouldMutateCombineSection } = (0, _contexts.useBasketContext)();
    const logger = (0, _logger.useLogger)('useRemoveHandler');
    const { endConsumerOrderId, isShippingOfferItem, itemCode, itemType, lineNumber, offerChoiceId, outOfStock, placement, requestedQuantity, handleChangedLineNumber, setChangedLineNumber } = removeProps;
    const removeMainItemHandler = (0, _react.useCallback)(async ()=>{
        setChangedLineNumber(null);
        const previousQuantity = requestedQuantity;
        if (handleChangedLineNumber) {
            handleChangedLineNumber(null);
        }
        try {
            setLoadingItem(lineNumber);
            if (itemType === 'a') {
                setShouldMutateCombineSection(true);
            }
            await (0, _utils.removeBasketItem)({
                itemCode,
                lineNumber,
                outOfStock,
                placement,
                previousQuantity
            });
        } catch (error) {
            (0, _utils.showErrorNotification)();
            logger.error(error);
        } finally{
            setLoadingItem(-1);
        }
    }, [
        handleChangedLineNumber,
        itemCode,
        itemType,
        lineNumber,
        logger,
        outOfStock,
        placement,
        requestedQuantity,
        setChangedLineNumber,
        setLoadingItem,
        setShouldMutateCombineSection
    ]);
    const removeOfferItemHandler = (0, _react.useCallback)(async ()=>{
        setChangedLineNumber(null);
        try {
            setLoadingItem(lineNumber);
            if (isShippingOfferItem) {
                await (0, _utils.deleteShippingOfferItem)({
                    placement: _analyticsData.Placement.Offers
                });
            } else {
                await (0, _utils.deleteOfferItem)({
                    itemCode,
                    choiceId: offerChoiceId,
                    placement: _analyticsData.Placement.Offers
                });
            }
        } catch (error) {
            (0, _utils.showErrorNotification)();
            logger.error(error);
        } finally{
            setLoadingItem(-1);
        }
    }, [
        isShippingOfferItem,
        itemCode,
        lineNumber,
        logger,
        offerChoiceId,
        setChangedLineNumber,
        setLoadingItem
    ]);
    const removeConsumerItemHandler = (0, _react.useCallback)(async ()=>{
        setChangedLineNumber(null);
        try {
            setLoadingItem(lineNumber);
            await (0, _utils.updateCustomerOrderItem)({
                endConsumerOrderId: endConsumerOrderId,
                itemCode,
                requestedQuantity: 0
            });
        } catch (error) {
            (0, _utils.showErrorNotification)();
            logger.error(error);
        } finally{
            setLoadingItem(-1);
        }
    }, [
        endConsumerOrderId,
        itemCode,
        lineNumber,
        logger,
        setChangedLineNumber,
        setLoadingItem
    ]);
    const removeItemHandler = (0, _react.useCallback)(async ()=>{
        if (typeof offerChoiceId === 'number') {
            return removeOfferItemHandler();
        } else if (typeof endConsumerOrderId === 'number') {
            return removeConsumerItemHandler();
        }
        return removeMainItemHandler();
    }, [
        endConsumerOrderId,
        offerChoiceId,
        removeConsumerItemHandler,
        removeMainItemHandler,
        removeOfferItemHandler
    ]);
    return {
        removeItemHandler,
        removeConsumerItemHandler,
        removeMainItemHandler,
        removeOfferItemHandler
    };
};
exports.useRemoveHandler = useRemoveHandler;
